import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M3 7v10a4 4 0 0 0 4 4h10c2.21 0 4-1.789 4-3.998V6.996A3.996 3.996 0 0 0 17 3H7a4 4 0 0 0-4 4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.4 7v10A2.6 2.6 0 0 0 7 19.6h10c1.437 0 2.6-1.163 2.6-2.598V6.996A2.597 2.597 0 0 0 17 4.4H7A2.6 2.6 0 0 0 4.4 7M3 17V7a4 4 0 0 1 4-4h10c2.21 0 4 1.787 4 3.996v10.006C21 19.212 19.21 21 17 21H7a4 4 0 0 1-4-4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.15 3.7a.7.7 0 0 1 .7-.7h6.323a.7.7 0 0 1 .7.7v11.197c0 1.031-1.216 1.582-1.991.902l-1.856-1.626-1.89 1.639c-.777.673-1.986.121-1.986-.907zm1.4.7v10.067L11.241 13a1.2 1.2 0 0 1 1.577.005l1.655 1.45V4.4zm-.331 10.354",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=CollectionSingleIcon24.js.map